import React from 'react';
import Inicio from './components/paginas/Inicio.jsx';
function Principal() {
    return(
            <React.StrictMode>
                <Inicio/> 
            </React.StrictMode>
);
}
export default Principal;
